// ======================================================================
// File Name       : DistributionOfferListDetailTitle
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import SelectBox from '../../components/SelectBox';

const DistributionViewTitle = ({
  doStartStopContent,
  serviceName,
  distributionStatus,
  offerType,
  onInputChange,
  onHandleOfferTypeChange,
}) => {
  let textDistributionStatus = null;
  let textButtonStatus = null;
  if (distributionStatus === 0) {
    textDistributionStatus = '停止中';
    textButtonStatus = 'コンテンツ配布再開';
  } else if (distributionStatus === 1) {
    textDistributionStatus = '配布中';
    textButtonStatus = 'コンテンツ配布停止';
  }
  const onChangeOfferType = (event) => {
    const { name, value } = event.target;
    onHandleOfferTypeChange(name, value);
  };
  return (
    <div>
      <Col sm={12} className="padding-left-clear margin-top-10 margin-bottom-10">
        <Col sm={4} className="lable-content">
          配布先サービス名
        </Col>
        <Col sm={7} className="lable-value">
          {serviceName}
        </Col>
      </Col>
      <Col sm={12} className="padding-left-clear margin-top-10 margin-bottom-10">
        <Col sm={4} className="lable-content margin-top-10">
          コンテンツ配信ステータス
        </Col>
        <Col sm={2} className="lable-value margin-top-10">
          {textDistributionStatus}
        </Col>
        <Col sm={5}>
          <Button className="btn-96" variant="primary" onClick={doStartStopContent}>
            {textButtonStatus}
          </Button>
        </Col>
      </Col>
      <Col sm={12} className="margin-top-10 margin-bottom-10">
        <Col sm={3} as={Form.Label}>
          配布種別
        </Col>
        <Col sm={7}>
          <SelectBox
            data={SELECT_BOX_DATA.DISTRIBUTION_OFFER_TYPE}
            name="offerType"
            value={offerType}
            onChange={onChangeOfferType}
          />
        </Col>
      </Col>
    </div>
  );
};

export default DistributionViewTitle;
